import styled from 'styled-components'
export { VideoTitle, VIDEO_TITLE_LINE_COUNT } from '../../Styled'

export const ExpandButtonPlaceholder = styled.span`
  position: relative;
  float: right;
  clear: both;
  color: var(--white, #fff);
  cursor: pointer;
  font-weight: 500;
  visibility: hidden;
  white-space: nowrap;
  pointer-events: none;
`

export const ExpandButtonActual = styled.span<{ $left: number; $top: number; $hidden?: boolean }>`
  position: absolute;
  left: ${({ $left }) => $left}px;
  top: ${({ $top }) => $top}px;
  color: var(--white, #fff);
  cursor: pointer;
  font-weight: 500;
  transform: translateY(-50%);
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
  white-space: nowrap;
`

export const CloseButton = styled.span`
  color: var(--white, #fff);
  font-weight: 500;
  padding-left: 0.2rem;
  position: relative;
  white-space: nowrap;
`
